// extracted by mini-css-extract-plugin
export default {"reportsView":"Reports_reportsView__cQzci","card":"Reports_card__ADjOt"};